import React, { useContext, useEffect, useState } from 'react';
import { DndProvider, DropTargetMonitor, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useNavigate, useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import ProductController, {
  OptionGroupItemType,
  OptionGroupType,
  SetItemProductType,
  SetMenuItemType,
} from '../../../controller/ProductController';
import { useToast } from '../../../controller/ToastController';
import { AuthContext } from '../../../navigation/AuthProvider';
import { CurrentStoreContext } from '../../../controller/StoreController';

const SetItemIndex = () => {
  const navigate = useNavigate();
  const showToast = useToast();
  const [setItemList, setSetItemList] = useState<SetMenuItemType[]>([]);
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const [isOpen, setIsOpen] = useState<boolean[]>([]);

  const navigateOptionDetails = (set_item_info?: SetMenuItemType) => {
    if (set_item_info) {
      navigate(`/product/setitem/edit`, { state: { setItemInfo: set_item_info } });
    } else navigate(`/product/setitem/edit`);
  };

  // API 호출
  const getSetProductData = async () => {
    try {
      const oRes = await ProductController.getAllSetPrdGroup(currentStore.value);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getAllSetPrdGroup', oResponse);
        if (oResponse.data) {
          setSetItemList([...oResponse.data]);
          let openTemp = new Array(oResponse.data.length).fill(true);
          setIsOpen([...openTemp]);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const changeIndexSetProductData = async () => {
    try {
      const oRes = await ProductController.editSetPrdGroupIdOrder(currentStore.value, setItemList);
      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('editSetPrdGroupIdOrder', oResponse);
        if (oResponse.data && oResponse.ok) {
          showToast('세트상품의 순서를 변경했어요');
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  useEffect(() => {
    getSetProductData();
  }, [currentStore]);

  const moveItem = (fromIndex: number, toIndex: number) => {
    if (toIndex < 1) toIndex = 0;
    else if (toIndex > setItemList.length - 1) toIndex = setItemList.length;
    const newItems = [...setItemList];
    const [movedItem] = newItems.splice(fromIndex, 1);
    newItems.splice(toIndex, 0, movedItem);
    setSetItemList(newItems);
    setIsOpen(new Array(setItemList.length).fill(true));
  };

  interface DraggableItemProps {
    item: SetMenuItemType;
    index: number;
    moveItem: (fromIndex: number, toIndex: number) => void;
  }

  const RenderSetItem = ({ item, index, moveItem }: DraggableItemProps) => {
    const [selectedIndex, setSelectedIndex] = useState<number>(index + 1);

    const changeIsOpen = () => {
      const dataTemp = isOpen;
      dataTemp[index] = !dataTemp[index];
      setIsOpen([...dataTemp]);
    };

    const [, drag] = useDrag({
      type: 'ITEM',
      item: { item, index },
    });

    const [, drop] = useDrop({
      accept: 'ITEM',
      hover: (item: { index: number }, monitor: DropTargetMonitor) => {
        if (item.index !== index) {
          moveItem(item.index, index);
          item.index = index;
        }
      },
    });

    const moveMenuItem = (mainIndex: number, fromIndex: number, toIndex: number) => {
      if (toIndex < 1) toIndex = 0;
      else if (toIndex > setItemList[mainIndex].product_list.length - 1)
        toIndex = setItemList[mainIndex].product_list.length;
      let newMainItems = [...setItemList];
      const newItems = [...newMainItems[mainIndex].product_list];
      const [movedItem] = newItems.splice(fromIndex, 1);
      newItems.splice(toIndex, 0, movedItem);
      newMainItems[mainIndex].product_list = newItems;
      setSetItemList(newMainItems);
    };

    return (
      <div key={index}>
        <div className={`listItem ${isOpen[index] && 'open'}`}>
          <div className="row gap">
            <div className="row">
              <input
                ref={(node) => drag(drop(node))}
                value={selectedIndex}
                autoFocus={false}
                onChange={(e) => {
                  setSelectedIndex(Number(e.target.value));
                }}
                onBlur={() => {
                  moveItem(index, selectedIndex - 1);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    moveItem(index, selectedIndex - 1);
                  }
                }}
              />
              {/* <img
                src={`${process.env.PUBLIC_URL}/svg/ic_arrow_up_box.svg`}
                onClick={() => orderUpChange(index)}
                alt="ic"
              />
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_arrow_down_box.svg`}
                onClick={() => orderDownChange(index)}
                alt="ic"
              /> */}
            </div>
            <h3>{item.set_type_name}</h3>
            {item.input_min !== 0 && <h5>필수선택 {item.input_min}개</h5>}
          </div>
          <div className="row gap">
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_edit.svg`}
              alt="ic"
              onClick={() => navigateOptionDetails(item)}
            />
            {/* <img src={`${process.env.PUBLIC_URL}/svg/ic_trashcan.svg`} alt="ic" /> */}
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_arrow_${
                isOpen[index] ? 'up' : 'down'
              }_grey.svg`}
              onClick={changeIsOpen}
              width={30}
              height={30}
              alt="ic"
            />
          </div>
        </div>
        {isOpen[index] && (
          <div className="menuList">
            {item.product_list.map((subItem: SetItemProductType, subIndex: number) => {
              return (
                <RenderOptionItem
                  key={`${index}_${subIndex}`}
                  mainIndex={index}
                  subItem={subItem}
                  subIndex={subIndex}
                  moveMenuItem={moveMenuItem}
                />
              );
            })}
          </div>
        )}
      </div>
    );
  };

  interface DraggableMenuItemProps {
    subItem: SetItemProductType;
    mainIndex: number;
    subIndex: number;
    moveMenuItem: (mainIndex: number, fromIndex: number, toIndex: number) => void;
  }

  const RenderOptionItem = ({
    subItem,
    mainIndex,
    subIndex,
    moveMenuItem,
  }: DraggableMenuItemProps) => {
    const [selectedMenuIndex, setSelectedMenuIndex] = useState<number>(subIndex + 1);

    const [, menuDrag] = useDrag({
      type: 'ITEM',
      item: { mainIndex, subItem, subIndex },
    });

    const [, menuDrop] = useDrop({
      accept: 'ITEM',
      hover: (item: { mainIndex: number; subIndex: number }, monitor: DropTargetMonitor) => {
        if (item.mainIndex === mainIndex && item.subIndex !== subIndex) {
          moveMenuItem(mainIndex, item.subIndex, subIndex);
          item.subIndex = subIndex;
        }
      },
    });

    return (
      <div className="menuItem" key={subIndex}>
        <div className="row">
          <input
            ref={(node) => menuDrag(menuDrop(node))}
            value={selectedMenuIndex}
            autoFocus={false}
            onChange={(e) => {
              setSelectedMenuIndex(Number(e.target.value));
            }}
            onBlur={() => {
              moveMenuItem(mainIndex, subIndex, selectedMenuIndex - 1);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                moveMenuItem(mainIndex, subIndex, selectedMenuIndex - 1);
              }
            }}
          />
          <div className="column">
            <h4>{subItem.prd_name}</h4>
            <h5>{subItem.price}원</h5>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Style>
      <div className="contentContainer">
        <button className="addButton" onClick={() => navigateOptionDetails()}>
          <img src={`${process.env.PUBLIC_URL}/svg/ic_plus.svg`} alt="ic" />
          <h4>세트구성 만들기</h4>
        </button>

        <DndProvider backend={HTML5Backend}>
          {setItemList.length > 0 ? (
            <div className="categoryList">
              {setItemList.map((item: SetMenuItemType, index: number) => {
                return <RenderSetItem key={index} item={item} index={index} moveItem={moveItem} />;
              })}
            </div>
          ) : (
            <div className="noneWrap">
              <h3>세트상품을 등록해주세요</h3>
            </div>
          )}
        </DndProvider>
        <button className={`submitButton`} onClick={changeIndexSetProductData}>
          저장
        </button>
      </div>
    </Style>
  );
};

export default SetItemIndex;

const Style = styled.div`
  @keyframes expandDown {
    0% {
      height: 0;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .addButton {
    width: 100%;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    padding: 8px 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5%;
    margin-bottom: 10px;

    h4 {
      font-weight: 600;
      color: #4dd2ae;
      white-space: nowrap;
      padding: 0;
    }
  }

  input {
    width: 30px;
    height: 30px;
    padding: 4px;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #40977f;
    background: #ecf5f3;
    border: 1px solid #4dd2ae;
    border-radius: 4px;
  }

  .categoryList {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .listItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 16px 10px 22px;
      background: #ecf5f3;
      border: 1px solid #ecf5f3;
      border-radius: 5px;

      .row {
        gap: 6px;
      }
      .row.gap {
        gap: 14px;
      }
      h3 {
        color: #555555;
        font-weight: 600;
      }
      h5 {
        color: #979797;
        font-weight: 500;
      }
    }
    .listItem.open {
      border-radius: 5px 5px 0 0;
    }

    .menuList {
      display: flex;
      flex-direction: column;
      border: 1px solid #e5e5e5;
      border-top: none;
      border-radius: 0 0 5px 5px;

      .menuItem {
        min-height: 65px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 2px 22px;
        border-bottom: 1px solid #f7f7f7;

        input {
          width: 24px;
          height: 24px;
          padding: 4px;
          font-size: 14px;
          line-height: 16px;
          color: #979797;
          background: #ffffff;
          border: 1px solid #cecece;
        }

        .column {
          gap: 2px;
        }
        h4 {
          color: #555555;
          font-weight: 600;
        }
        h5 {
          color: #555555;
          font-weight: 400;
        }
        .row {
          gap: 20px;

          .imgWrap {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 60px;
            height: 60px;
            border-radius: 5px;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              border-radius: 5px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    .categoryList {
      gap: 20px;

      .listItem {
        padding: 8px 10px 8px 16px;

        input {
          width: 26px;
          height: 26px;
          font-size: 14px;
        }
        h3 {
          font-size: 16px;
        }
        h5 {
          font-size: 10px;
          white-space: nowrap;
          padding-right: 6px;
        }
      }

      .menuList {
        .menuItem {
          min-height: 50px;
          padding: 2px 16px;

          .setBadge {
            padding: 2px 8px;
            font-size: 12px;
            line-height: 14px;
          }
          input {
            width: 22px;
            height: 22px;
            padding: 4px;
            font-size: 12px;
            line-height: 14px;
          }

          .column {
            .row {
              gap: 6px;
            }
          }
          h4 {
            font-size: 14px;
            color: #555555;
            font-weight: 600;
          }
          h5 {
            font-size: 12px;
            color: #555555;
            font-weight: 400;
          }
          .row {
            gap: 14px;
            .imgWrap {
              width: 46px;
              height: 46px;
            }
          }
        }
      }
    }
  }
`;
